export default "__VITE_ASSET__9305e15a__"